import { EventRecord } from "@/modules/user/types/events";
import { apiWithAuth } from "../authApi";

interface GetUserEventsPayload {
  offset?: number;
  limit?: number | null;
  lastShownEventCreatedDate?: string | null;
}

export const postGetEventsApply = async (
  payload: GetUserEventsPayload
): Promise<EventRecord[] | undefined> => {
  try {
    const response = await apiWithAuth.post("/user/events", payload);

    const answer = response.data.data as EventRecord[];

    return answer;
  } catch (error) {
    return undefined;
  }
};
